import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { routesAllowedForFutureYears, validateSearchParams } from "../utils/ValidationUtils";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";

/**
 * Props for the ValidatorRouteWrapper component.
 */
interface ValidatorRouteWrapperProps extends RouteProps {
  children: JSX.Element;
}

/**
 * Wrapper component for validating search parameters and rendering child components.
 * If the search parameters are invalid, it redirects to the "/dashboard" route.
 */
const ValidatorRouteWrapper: React.FC<ValidatorRouteWrapperProps> = ({ children, path }) => {
  const setRoutesAllowedForFutureYears = new Set(routesAllowedForFutureYears);
  //normalizes the input
  const pathInArrayFormat = [].concat(path);
  const allowFutureYears = pathInArrayFormat.some((route) => setRoutesAllowedForFutureYears.has(route));
  const params = new URLSearchParams(window.location.search);
  const isValidParams = validateSearchParams(params, !!allowFutureYears);

  if (!isValidParams) {
    const errorMessage = `The route validation failed${
      !allowFutureYears ? ", possibly because the date was in the future and unconfigured." : ""
    }`;
    NotificationService.error(errorMessage);
    return <Redirect to="/dashboard" />;
  }

  return children;
};

export default ValidatorRouteWrapper;
